import React, { useEffect } from 'react'
import Modal from 'react-modal'
import { Link } from 'react-router-dom';
import { PaymentForm, CreditCard } from 'react-square-web-payments-sdk';
import { getFunctions, httpsCallable } from 'firebase/functions';

const BuyCoinModal = (props) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const functions = getFunctions();
    const buyCoinFunc = httpsCallable(functions, 'buyCoin');

    // モーダルの表示状態を更新
    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    // コイン購入後の処理
    const afterPayment = (result) => {
        console.log(result);
        alert('クレジットが追加されました。ご購入ありがとうございました。');
        window.location.reload();
    }

    // モーダルのスタイル
    const customStyles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.3)"
        },
        content: {
          top: '60px',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, 0%)',
          boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.2)',
          maxWidth: '85%',
          maxHeight: '80vh',
          overflowY: 'auto',
          borderRadius: '10px',
          textAlign: 'center',
        },
    };

  return (
    <Modal
        contentLabel="クレジットの購入"
        style={customStyles}
        isOpen={modalIsOpen}
    >
        <h2 className='text-2xl mb-2 text-purple-700 me-8'>クレジットの購入</h2>
        <button onClick={() => props.onClose()} className='absolute top-4 end-4 text-xl text-gray-500'><i className='bi bi-x-lg'></i></button>

        <hr className='my-3' />

        <div className='text-left mb-3 text-base text-gray-600 flex justify-between'>
            <span>追加クレジット数<span className='text-xl ms-2 font-medium'>{props.coin} pt</span></span>
            <span>価格<span className='text-xl ms-2 font-medium'>￥{Number(props.price).toLocaleString()}</span></span>
        </div>

        <div className='text-left mb-3 text-sm text-gray-500'>
            <Link to="/info/notations_sct" target="_blank" className='hover:underline'><i className='bi bi-exclamation-circle me-1'></i>特商法に基づく表記</Link>
        </div>

        <h3 className='text-start text-gray-500 mb-2'>クレジットカードで支払い</h3>
        <PaymentForm
            applicationId={process.env.REACT_APP_SQUARE_APP_ID}
            cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
                if (token.status !== 'OK' || !token.token) {
                    console.error(token.errors);
                    alert('カード情報が正しくありません。入力内容をご確認の上、再度お試しください。');
                    return;
                }
                try {
                    const response = await buyCoinFunc({
                        sourceId: token.token,
                        coin: props.coin,
                    });
                    afterPayment(response.data);
                } catch (error) {
                    console.error(error);
                    alert('決済に失敗しました。時間をおいて再度お試しください。\n' + (error.message || ''));
                }
            }}
            locationId={process.env.REACT_APP_SQUARE_LOCATION_ID}
        >
            <CreditCard />
        </PaymentForm>
        <p className='text-sm text-gray-500 mb-4 mt-2'>「Pay」を押すと支払いが確定します<br />数秒そのままお待ちください</p>

        {/* 資金決済法に基づく表示 */}
        <div className='text-left'>
            <h3 className='text-lg font-medium text-gray-800 mb-3'>資金決済法に基づく表示</h3>
            <div className='text-sm text-gray-700 space-y-1'>
                <div>
                    <span className='font-medium'>発行者の氏名または名称:</span> 合同会社FunAMP
                </div>
                <div>
                    <span className='font-medium'>代表者氏名:</span> 松浦竜征
                </div>
                <div>
                    <span className='font-medium'>所在地:</span> 東京都新宿区西新宿三丁目3番13号 西新宿水間ビル2階
                </div>
                <div>
                    <span className='font-medium'>問い合わせ先:</span> <a href="mailto:metrotagcomittee@gmail.com" className='text-purple-600 hover:underline'>metrotagcomittee@gmail.com</a>
                </div>
                <div>
                    <span className='font-medium'>利用可能な範囲:</span> Webアプリ「電鬼2」内のゲーム実行時に使用可能
                </div>
                <div>
                    <span className='font-medium'>有効期限:</span> 期限なし
                </div>
                <div>
                    <span className='font-medium'>払戻しの有無と条件:</span> 法令に基づく場合を除き、払戻しは行いません
                </div>
                <div>
                    <span className='font-medium'>利用規約:</span> <Link to="/info/terms" target="_blank" className='text-purple-600 hover:underline'>利用規約</Link>
                </div>
                <div>
                    <span className='font-medium'>特商法に基づく表示:</span> <Link to="/info/notations_sct" target="_blank" className='text-purple-600 hover:underline'>特商法に基づく表記</Link>
                </div>
            </div>
        </div>
    </Modal>
  )
}

export default BuyCoinModal
